import { PageHero, Container, DarkCTA } from "@/components/Sections";
import { Reveal } from "@/components/Reveal";
import { Star, ArrowUpRight } from "lucide-react";
import { REVIEWS, IMAGES, GOOGLE_REVIEWS_URL } from "@/data/site";

export default function Recensioni() {
  return (
    <>
      <PageHero overline="Recensioni Google" title="4,9 su 5, oltre 200 clienti." img={IMAGES.movers}
        subtitle="La fiducia dei nostri clienti è il nostro biglietto da visita. Ecco cosa dicono di AXAL Logistics." />
      <section className="py-24 md:py-32" data-testid="all-reviews">
        <Container>
          <div className="flex justify-center mb-12">
            <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" data-testid="recensioni-google-link"
              className="h-14 px-8 rounded-full bg-[#FF5A00] text-white font-bold inline-flex items-center gap-2 hover:bg-[#E04F00] transition-colors">
              Leggi le recensioni su Google <ArrowUpRight size={18} />
            </a>
          </div>
          <div className="columns-1 md:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
            {[...REVIEWS, ...REVIEWS].map((r, i) => (
              <Reveal key={i} delay={(i % 3) * 0.06}>
                <div className="break-inside-avoid mb-5 bg-white border border-zinc-100 rounded-2xl p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
                  <div className="flex gap-1 mb-4">{[...Array(r.rating)].map((_, j) => <Star key={j} size={16} className="text-[#FF5A00] fill-[#FF5A00]" />)}</div>
                  <p className="text-zinc-700 leading-relaxed text-[15px]">"{r.text}"</p>
                  <div className="flex items-center gap-3 mt-6">
                    <div className="w-10 h-10 rounded-full bg-[#FF5A00]/10 flex items-center justify-center font-head font-bold text-[#FF5A00]">{r.name[0]}</div>
                    <div>
                      <div className="font-bold text-sm">{r.name}</div>
                      <div className="text-zinc-400 text-xs">{r.city} · Google</div>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
      <DarkCTA />
    </>
  );
}
